import { FileContent, FileContentFactory, News } from ".."

export interface ModifyNews {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    link: string
    image: FileContent
}

export class ModifyNewsFactory {
    static create(): ModifyNews {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            descriptions: {},
            link: "",
            image: FileContentFactory.create(),
        }
    }

    static from(news: News): ModifyNews {
        const modifyNews: ModifyNews = JSON.parse(
            JSON.stringify({
                isDraft: news.isDraft,
                isActive: news.isActive,
                isDeleted: news.isDeleted,
                names: news.names,
                descriptions: news.descriptions,
                link: news.link,
                image: FileContentFactory.fromUrl(news.imageUrl ?? ""),
            })
        )
        return modifyNews
    }
}
